import React, { useState } from "react"
import { Row, Col, Tabs, Space, Divider } from "antd"
import {
  BankOutlined,
  AppstoreOutlined,
  TeamOutlined,
  BarChartOutlined,
} from "@ant-design/icons"
import NotificationPanel from "../components/NotificationPanel"
import BankTransactions from "../components/BankTransactions"
import ListExecutor from "../components/ListExecutor"
import MetabaseSection from "../components/MetabaseSection"

const AccountantDashboard = ({
  infoMessage,
  telegramLink,
  userInfo,
  iframeUrl,
  showMetabase = false,
}) => {
  const [selectedUserId, setSelectedUserId] = useState(null)

  const tabItems = [
    {
      key: "1",
      label: (
        <Space>
          <AppstoreOutlined />
          نمای کلی
        </Space>
      ),
      children: (
        <Row gutter={[16, 16]}>
          {infoMessage && (
            <Col span={24}>
              <NotificationPanel
                messages={infoMessage}
                telegramLink={telegramLink}
              />
            </Col>
          )}
        </Row>
      ),
    },
  ]

  if (showMetabase) {
    tabItems.push({
      key: "2",
      label: (
        <Space>
          <BarChartOutlined />
          داشبورد تحلیلی
        </Space>
      ),
      children: <MetabaseSection iframeUrl={iframeUrl} loading={!iframeUrl} />,
    })
  }

  tabItems.push({
    key: "3",
    label: (
      <Space>
        <BankOutlined />
        تراکنش‌های بانکی
      </Space>
    ),
    children: (
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <div style={{ marginBottom: 16 }}>
            <Space align="center" style={{ marginBottom: 8 }}>
              <TeamOutlined style={{ color: "#1890ff" }} />
              <span style={{ fontWeight: 600 }}>انتخاب مجری</span>
            </Space>
            <ListExecutor
              selectedUserId={selectedUserId}
              onSelectUser={setSelectedUserId}
            />
          </div>
          <Divider style={{ margin: "12px 0" }} />
          <BankTransactions userId={selectedUserId} canReconcile />
        </Col>
      </Row>
    ),
  })

  return (
    <Tabs
      defaultActiveKey="1"
      items={tabItems}
      style={{ background: "#fff", borderRadius: 12, padding: "0 8px" }}
    />
  )
}

export default AccountantDashboard
